import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	greyLightest: {
		id: 'business-categories.category-form.category-color-picker.grey-lightest',
		defaultMessage: 'Grey lightest',
		description: 'Tooltip text for grey lightest color',
	},
	greyLighter: {
		id: 'business-categories.category-form.category-color-picker.grey-lighter',
		defaultMessage: 'Grey lighter',
		description: 'Tooltip text for grey lightest color',
	},
	grey: {
		id: 'business-categories.category-form.category-color-picker.grey',
		defaultMessage: 'Grey',
		description: 'Tooltip text for grey color',
	},
	greyDarker: {
		id: 'business-categories.category-form.category-color-picker.grey-darker',
		defaultMessage: 'Grey darker',
		description: 'Tooltip text for grey darker color',
	},
	greyDarkest: {
		id: 'business-categories.category-form.category-color-picker.grey-darkest',
		defaultMessage: 'Grey darkest',
		description: 'Tooltip text for grey darkest color',
	},
	purpleLightest: {
		id: 'business-categories.category-form.category-color-picker.purple-lightest',
		defaultMessage: 'Purple lightest',
		description: 'Tooltip text for purple lightest color',
	},
	purpleLighter: {
		id: 'business-categories.category-form.category-color-picker.purple-lighter',
		defaultMessage: 'Purple lighter',
		description: 'Tooltip text for purple lightest color',
	},
	purple: {
		id: 'business-categories.category-form.category-color-picker.purple',
		defaultMessage: 'Purple',
		description: 'Tooltip text for purple color',
	},
	purpleDarker: {
		id: 'business-categories.category-form.category-color-picker.purple-darker',
		defaultMessage: 'Purple darker',
		description: 'Tooltip text for purple darker color',
	},
	purpleDarkest: {
		id: 'business-categories.category-form.category-color-picker.purple-darkest',
		defaultMessage: 'Purple darkest',
		description: 'Tooltip text for purple darkest color',
	},
	blueLightest: {
		id: 'business-categories.category-form.category-color-picker.blue-lightest',
		defaultMessage: 'Blue lightest',
		description: 'Tooltip text for blue lightest color',
	},
	blueLighter: {
		id: 'business-categories.category-form.category-color-picker.blue-lighter',
		defaultMessage: 'Blue lighter',
		description: 'Tooltip text for blue lightest color',
	},
	blue: {
		id: 'business-categories.category-form.category-color-picker.blue',
		defaultMessage: 'Blue',
		description: 'Tooltip text for blue color',
	},
	blueDarker: {
		id: 'business-categories.category-form.category-color-picker.blue-darker',
		defaultMessage: 'Blue darker',
		description: 'Tooltip text for blue darker color',
	},
	blueDarkest: {
		id: 'business-categories.category-form.category-color-picker.blue-darkest',
		defaultMessage: 'Blue darkest',
		description: 'Tooltip text for blue darkest color',
	},
	tealLightest: {
		id: 'business-categories.category-form.category-color-picker.teal-lightest',
		defaultMessage: 'Teal lightest',
		description: 'Tooltip text for teal lightest color',
	},
	tealLighter: {
		id: 'business-categories.category-form.category-color-picker.teal-lighter',
		defaultMessage: 'Teal lighter',
		description: 'Tooltip text for teal lightest color',
	},
	teal: {
		id: 'business-categories.category-form.category-color-picker.teal',
		defaultMessage: 'Teal',
		description: 'Tooltip text for teal color',
	},
	tealDarker: {
		id: 'business-categories.category-form.category-color-picker.teal-darker',
		defaultMessage: 'Teal darker',
		description: 'Tooltip text for teal darker color',
	},
	tealDarkest: {
		id: 'business-categories.category-form.category-color-picker.teal-darkest',
		defaultMessage: 'Teal darkest',
		description: 'Tooltip text for teal darkest color',
	},
	greenLightest: {
		id: 'business-categories.category-form.category-color-picker.green-lightest',
		defaultMessage: 'Green lightest',
		description: 'Tooltip text for green lightest color',
	},
	greenLighter: {
		id: 'business-categories.category-form.category-color-picker.green-lighter',
		defaultMessage: 'Green lighter',
		description: 'Tooltip text for green lightest color',
	},
	green: {
		id: 'business-categories.category-form.category-color-picker.green',
		defaultMessage: 'Green',
		description: 'Tooltip text for green color',
	},
	greenDarker: {
		id: 'business-categories.category-form.category-color-picker.green-darker',
		defaultMessage: 'Green darker',
		description: 'Tooltip text for green darker color',
	},
	greenDarkest: {
		id: 'business-categories.category-form.category-color-picker.green-darkest',
		defaultMessage: 'Green darkest',
		description: 'Tooltip text for green darkest color',
	},
	limeLightest: {
		id: 'business-categories.category-form.category-color-picker.lime-lightest',
		defaultMessage: 'Lime lightest',
		description: 'Tooltip text for lime lightest color',
	},
	limeLighter: {
		id: 'business-categories.category-form.category-color-picker.lime-lighter',
		defaultMessage: 'Lime lighter',
		description: 'Tooltip text for lime lightest color',
	},
	lime: {
		id: 'business-categories.category-form.category-color-picker.lime',
		defaultMessage: 'Lime',
		description: 'Tooltip text for lime color',
	},
	limeDarker: {
		id: 'business-categories.category-form.category-color-picker.lime-darker',
		defaultMessage: 'Lime darker',
		description: 'Tooltip text for lime darker color',
	},
	limeDarkest: {
		id: 'business-categories.category-form.category-color-picker.lime-darkest',
		defaultMessage: 'Lime darkest',
		description: 'Tooltip text for lime darkest color',
	},
	yellowLightest: {
		id: 'business-categories.category-form.category-color-picker.yellow-lightest',
		defaultMessage: 'Yellow lightest',
		description: 'Tooltip text for yellow lightest color',
	},
	yellowLighter: {
		id: 'business-categories.category-form.category-color-picker.yellow-lighter',
		defaultMessage: 'Yellow lighter',
		description: 'Tooltip text for yellow lightest color',
	},
	yellow: {
		id: 'business-categories.category-form.category-color-picker.yellow',
		defaultMessage: 'Yellow',
		description: 'Tooltip text for yellow color',
	},
	yellowDarker: {
		id: 'business-categories.category-form.category-color-picker.yellow-darker',
		defaultMessage: 'Yellow darker',
		description: 'Tooltip text for yellow darker color',
	},
	yellowDarkest: {
		id: 'business-categories.category-form.category-color-picker.yellow-darkest',
		defaultMessage: 'Yellow darkest',
		description: 'Tooltip text for yellow darkest color',
	},
	orangeLightest: {
		id: 'business-categories.category-form.category-color-picker.orange-lightest',
		defaultMessage: 'Orange lightest',
		description: 'Tooltip text for orange lightest color',
	},
	orangeLighter: {
		id: 'business-categories.category-form.category-color-picker.orange-lighter',
		defaultMessage: 'Orange lighter',
		description: 'Tooltip text for orange lightest color',
	},
	orange: {
		id: 'business-categories.category-form.category-color-picker.orange',
		defaultMessage: 'Orange',
		description: 'Tooltip text for orange color',
	},
	orangeDarker: {
		id: 'business-categories.category-form.category-color-picker.orange-darker',
		defaultMessage: 'Orange darker',
		description: 'Tooltip text for orange darker color',
	},
	orangeDarkest: {
		id: 'business-categories.category-form.category-color-picker.orange-darkest',
		defaultMessage: 'Orange darkest',
		description: 'Tooltip text for orange darkest color',
	},
	redLightest: {
		id: 'business-categories.category-form.category-color-picker.red-lightest',
		defaultMessage: 'Red lightest',
		description: 'Tooltip text for red lightest color',
	},
	redLighter: {
		id: 'business-categories.category-form.category-color-picker.red-lighter',
		defaultMessage: 'Red lighter',
		description: 'Tooltip text for red lightest color',
	},
	red: {
		id: 'business-categories.category-form.category-color-picker.red',
		defaultMessage: 'Red',
		description: 'Tooltip text for red color',
	},
	redDarker: {
		id: 'business-categories.category-form.category-color-picker.red-darker',
		defaultMessage: 'Red darker',
		description: 'Tooltip text for red darker color',
	},
	redDarkest: {
		id: 'business-categories.category-form.category-color-picker.red-darkest',
		defaultMessage: 'Red darkest',
		description: 'Tooltip text for red darkest color',
	},
	magentaLightest: {
		id: 'business-categories.category-form.category-color-picker.magenta-lightest',
		defaultMessage: 'Magenta lightest',
		description: 'Tooltip text for magenta lightest color',
	},
	magentaLighter: {
		id: 'business-categories.category-form.category-color-picker.magenta-lighter',
		defaultMessage: 'Magenta lighter',
		description: 'Tooltip text for magenta lightest color',
	},
	magenta: {
		id: 'business-categories.category-form.category-color-picker.magenta',
		defaultMessage: 'Magenta',
		description: 'Tooltip text for magenta color',
	},
	magentaDarker: {
		id: 'business-categories.category-form.category-color-picker.magenta-darker',
		defaultMessage: 'Magenta darker',
		description: 'Tooltip text for magenta darker color',
	},
	magentaDarkest: {
		id: 'business-categories.category-form.category-color-picker.magenta-darkest',
		defaultMessage: 'Magenta darkest',
		description: 'Tooltip text for magenta darkest color',
	},
});
